module.exports = __webpack_public_path__ + "static/media/cloudzapi_login.02a6dfd7.png";